import { computed, watch, ref } from 'vue';
import { useStore } from 'vuex';

export default function t(key, fallback = '') {
    // use the current locale to get the good json file and return the value
    const store = useStore();
    const locale = computed(() => store.getters['config/locale']);

    try {
        // Charger le fichier de traduction correspondant à la locale
        const jsonFile = require(`../lang/${locale.value}.json`);

        // Récupérer la traduction
        let translation = jsonFile[key];

        // Si la traduction n'existe pas, essayer la locale de fallback (fr)
        if (!translation && locale.value !== 'fr') {
            const fallbackFile = require(`../lang/fr.json`);
            translation = fallbackFile[key];
        }

        // Si toujours pas de traduction, utiliser la valeur par défaut
        if (!translation) {
            translation = fallback || key;
        }

        return translation;

    } catch (error) {
        console.warn(`Erreur de chargement de la traduction pour la clé "${key}":`, error);
        return fallback || key;
    }
}
